var map = {
  "./uk.json": [
    "19205",
    [
      63449
    ]
  ],
  "./fi.json": [
    "25712",
    [
      12926
    ]
  ],
  "./el.json": [
    "44884",
    [
      40878
    ]
  ],
  "./fr-CA.json": [
    "54196",
    [
      45422
    ]
  ],
  "./ja.json": [
    "75012",
    [
      80642
    ]
  ],
  "./ar.json": [
    "87622",
    [
      99868
    ]
  ],
  "./nn.json": [
    "3521",
    [
      94481
    ]
  ],
  "./cy.json": [
    "42461",
    [
      14225
    ]
  ],
  "./sl.json": [
    "6350",
    [
      35740
    ]
  ],
  "./fr.json": [
    "94165",
    [
      52293
    ]
  ],
  "./ga.json": [
    "57985",
    [
      11333
    ]
  ],
  "./sv-x-k12.json": [
    "95926",
    [
      57096
    ]
  ],
  "./da-x-k12.json": [
    "48876",
    [
      41582
    ]
  ],
  "./nb.json": [
    "79997",
    [
      73917
    ]
  ],
  "./sv.json": [
    "4900",
    [
      95806
    ]
  ],
  "./en-CA.json": [
    "74917",
    [
      94689
    ]
  ],
  "./en.json": [
    "85126",
    []
  ],
  "./pl.json": [
    "94637",
    [
      4717
    ]
  ],
  "./es-ES.json": [
    "47776",
    [
      92318
    ]
  ],
  "./nb-x-k12.json": [
    "24187",
    [
      31643
    ]
  ],
  "./hu.json": [
    "94770",
    [
      47348
    ]
  ],
  "./pt-BR.json": [
    "66848",
    [
      69998
    ]
  ],
  "./th.json": [
    "51029",
    [
      91829
    ]
  ],
  "./ca.json": [
    "95429",
    [
      11225
    ]
  ],
  "./de.json": [
    "40862",
    [
      4624
    ]
  ],
  "./hy.json": [
    "49510",
    [
      51064
    ]
  ],
  "./zh-Hant.json": [
    "37619",
    [
      43575
    ]
  ],
  "./vi.json": [
    "68224",
    [
      85806
    ]
  ],
  "./ht.json": [
    "46173",
    [
      40893
    ]
  ],
  "./tr.json": [
    "56211",
    [
      87975
    ]
  ],
  "./en-GB.json": [
    "56628",
    [
      28126
    ]
  ],
  "./da.json": [
    "33602",
    [
      31732
    ]
  ],
  "./en-AU.json": [
    "95931",
    [
      89459
    ]
  ],
  "./he.json": [
    "8322",
    [
      92900
    ]
  ],
  "./id.json": [
    "10752",
    [
      31802
    ]
  ],
  "./es.json": [
    "80141",
    [
      94113
    ]
  ],
  "./ko.json": [
    "67367",
    [
      60439
    ]
  ],
  "./zh-Hans.json": [
    "11902",
    [
      77760
    ]
  ],
  "./ms.json": [
    "22981",
    [
      35145
    ]
  ],
  "./is.json": [
    "48889",
    [
      55021
    ]
  ],
  "./nl.json": [
    "19527",
    [
      24875
    ]
  ],
  "./fa.json": [
    "18792",
    [
      30918
    ]
  ],
  "./pt.json": [
    "67925",
    [
      7557
    ]
  ],
  "./ru.json": [
    "77040",
    [
      26414
    ]
  ],
  "./it.json": [
    "34704",
    [
      22922
    ]
  ],
  "./mi.json": [
    "99587",
    [
      83227
    ]
  ],
  "./hi.json": [
    "82646",
    [
      51528
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 89683;
module.exports = __rspack_async_context;
